import { newrelicAgentSnippet } from '@/lib/newrelic-browser-agent';

export const NewRelicSnippet = () => {
  if (!process.env.NEXT_PUBLIC_NEW_RELIC_LICENSE_KEY) return null;

  return (
    <script
      type="text/javascript"
      dangerouslySetInnerHTML={{ __html: newrelicAgentSnippet }}
    />
  );
};
